import { render, staticRenderFns } from "./simplifyOwnerRooms.vue?vue&type=template&id=8b15fd8e&scoped=true"
import script from "./simplifyOwnerRooms.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerRooms.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerRooms.vue?vue&type=style&index=0&id=8b15fd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b15fd8e",
  null
  
)

export default component.exports